/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'header-exclude-alert',
  templateUrl: './header-exclude-alert.component.html',
  styleUrls: ['./header-exclude-alert.component.less'],
  standalone: false,
})
export class HeaderExcludeAlertComponent {
  @Input() title: string;
  @Input() body: string;
  @Input() buttonText = 'SDE_CLOSE';
  @Input() additional: string;
  @Input() dangerButtonText: string;
  @Input() okButtonText: string;

  constructor(public activeModal: NgbActiveModal) {}
}
